<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto;">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px">
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">操作日志详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <!-- prop="ResourceName" -->
      <zj-layout-main>
        <el-form ref="form" :model="data" :rules="rules" label-width="16rem" style="width: 80%;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户名" prop="UserName">
                <el-input v-model="data.UserName" disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="等级" prop="LogLevel">
                <el-input v-model="data.LogLevel" disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="所属模块" prop="ModuleName">
                <el-input v-model="data.ModuleName" disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="所属页面" prop="PageName">
                <el-input v-model="data.PageName" disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="时间" prop="LogDate">
                <el-date-picker
                  type="datetime"
                  style="width: 100%;"
                  placeholder="选择日期"
                  v-model="data.LogDate"
                  v-bind:disabled="true"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="日志信息" prop="LogMessage">
                <el-input v-model="data.LogMessage" disabled="true" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="当前异常信息" prop="ErrMessage">
                <el-input v-model="data.ErrMessage" disabled="true" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
           <el-row>
            <el-col :span="24">
              <el-form-item label="堆栈信息" prop="StackTrace">
                <el-input v-model="data.StackTrace" disabled="true" type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </zj-layout-main>
      <el-form-item class="right" style="width:134rem;">
        <el-button @click="onBack()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";

export default {
  name: "ErrorLogDetail",
  controller: "UI",
  action: "ErrorLogDetail",
  data() {
    return {
      data: {}
    };
  },
  created: function() {
    if (this.$route.query.InfoId) {
      this.search();
    }
  },
  mounted: function() {},
  watch: {
    $route: function() {
      if (this.$route.query.InfoId) {
        this.search();
      }
    }
  },
  methods: {
    search() {
      let InfoId = this.$route.query.InfoId;
      if (InfoId) {
        let searchInfo = {
          LogId: InfoId
        };
        new MyApis.ErrorLogApi()
          .GeItemById(searchInfo)
          .then(r => {
            r = r.data.Data;
            console.log(r);
            this.data = r;
          })
          .catch(e => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    }
  }
};
</script>